import { render } from "./OrderFormProductsSummary.vue?vue&type=template&id=64e74c2d&scoped=true&ts=true"
import script from "./OrderFormProductsSummary.vue?vue&type=script&lang=ts"
export * from "./OrderFormProductsSummary.vue?vue&type=script&lang=ts"

import "./OrderFormProductsSummary.vue?vue&type=style&index=0&id=64e74c2d&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e74c2d"]])

export default __exports__